module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-end wrapper mt-5 pb-3"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 d-none d-sm-block"
  }, [_c('img', {
    staticClass: "img-fluid rounded popper1",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9"
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-start"
  }, [_c('img', {
    staticClass: "kotori img-fluid rounded col-3 d-block d-sm-none d-md-none d-lg-none popper2",
    attrs: {
      "src": _vm.kotoriImg
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "mt-5 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center"
  }, [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center form-pc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputUrl),
      expression: "inputUrl"
    }],
    ref: "urlInput",
    staticClass: "col-12 col-sm-9 url-input form-control-lg mr-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('placeHolder'),
      "value": ""
    },
    domProps: {
      "value": (_vm.inputUrl)
    },
    on: {
      "click": _vm.urlInputOnClick,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.urlInputOnClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "col-12 col-sm-2 btn btn-kawaii text-white",
    attrs: {
      "id": "get-url-btn"
    },
    on: {
      "click": _vm.getShortUrl
    }
  }, [_vm._v(_vm._s(_vm.buttonText) + "\n                "), _c('div', {
    staticClass: "loader",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "get-url-loader"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9 offset-sm-3"
  }, _vm._l((_vm.shortUrls), function(shortUrl, index) {
    return _c('div', {
      staticClass: "mt-1 mt-md-3"
    }, [_c('div', {
      staticClass: "alert alert-trans alert-success",
      attrs: {
        "role": "alert",
        "id": 'shortUrl-' + index
      }
    }, [_c('a', {
      attrs: {
        "href": shortUrl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(shortUrl))]), _vm._v(" "), _c('a', {
      staticClass: "clipboard-a",
      attrs: {
        "href": "#",
        "data-clipboard-text": shortUrl
      }
    }, [_c('i', {
      staticClass: "fa fa-chain"
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15145cd7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main.vue
// module id = 42
// module chunks = 0